import { css } from '@emotion/react';

export const FlexCenter = css`
  align-items: center;
  display: flex;
  justify-content: center;
`;
export const FlexSpaceBetween = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const FlexCenterCol = css`
  ${FlexCenter}
  flex-direction: column;
`;

export const GridCenter = css`
  display: grid;
  place-content: center;
`;

export const ButtonResets = css`
  background-color: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 0;
`;
